/* eslint-disable react-hooks/exhaustive-deps */

// React Imports
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Component Imports
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import ConfidentialCard from "../../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";

// Utils Imports
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";

import ICONS from "../../../../../assets/Icons";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../../components/_utils/CommonLayout";

const CreateBank = ({
  setBankLookupNext,
  bankLookupNext,
  nextButtonEnabled,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  setBankIsArchived,
  setBankIsApproved,
  setBankIsDennied,
  setBankIsPending,
  hideBankBlock,
  setBankHideBlock,
  isButtonDisabled,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  isBankError,
  virtualAccount,
  setVirtualAccount,
  previousId,
  setPreviousBankNo,
  manualVirtualAccount,
  setManualVirtualAccount,
  ownerAccIfscData,
  ownerAccIfscError,
  canMarkAsVirtualAccount,
  type,
}) => {
  const {
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupLoading,
    ifscDetailsLoading,
    bankLookupError,
    verifyBankAccountData,
  } = useSelector((state) => state.sharedResources);

  const dropDownOptions = [
    "Reimbursement account",
    // "Field force account",
    "Beneficiary account",
  ];

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(dropDownOptions[0]);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [isCreateAccount, setIsCreateAccount] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const ifscData = ownerAccIfscData?.ifsc_details?.[0];
  const manualVirtualAccountReady =
    manualVirtualAccount &&
    !ifscDetailsLoading &&
    ownerAccIfscData?.status !== false &&
    Boolean(ifscData) &&
    !ownerAccIfscError;
  const bankDetailsIfscData =
    manualVirtualAccount && !manualVirtualAccountReady ? null : ifscData;

  const getAssociateLabel = (t) =>
    // t === "field_force"
    //   ? "Field force account"
    //   :
    t === "reimbursement" ? "Reimbursement account" : "Beneficiary account";

  const getActiveState = (s) =>
    ["rejected", "blocked", "archived"].includes(s) ? "inactive" : "active";

  const hasValidInput =
    payload?.bank_account?.length >= GlobalConfiguration?.accountnormalLength &&
    payload?.ifsc_code?.length === GlobalConfiguration?.ifscLength;

  const accounts =
    hasValidInput && bankLookupData?.status === true
      ? bankLookupData?.beneficiary_accounts || []
      : [];
  const accountTypeAvailability = {
    beneficiary: accounts.some(
      (account) => account?.type_of_account === "beneficiary",
    ),
    reimbursement: accounts.some(
      (account) => account?.type_of_account === "reimbursement",
    ),
  };
  const findPreferredAssociateAccount = (accountType) => {
    const matchingAccounts = accounts.filter(
      (account) => account?.type_of_account === accountType,
    );

    return (
      matchingAccounts.find(
        (account) => getActiveState(account?.approval_status) === "active",
      ) || matchingAccounts[0]
    );
  };
  const preferredAssociateAccount =
    findPreferredAssociateAccount("reimbursement") ||
    findPreferredAssociateAccount("beneficiary") ||
    findPreferredAssociateAccount("field_force");
  const associateDropDownNo =
    preferredAssociateAccount?.type_of_account === "beneficiary"
      ? GlobalConfiguration?.lengthCheckZero
      : GlobalConfiguration?.lengthCheckOne;

  useEffect(() => {
    bankLookupData?.beneficiary_accounts?.forEach((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [bankLookupData]);

  useEffect(() => {
    const foundAccount = bankLookupData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        setIsCreateAccount(true);

        return true;
      }
      return false;
    });

    if (foundAccount) {
      setCurrentAssociate(getAssociateLabel(foundAccount?.type_of_account));
    }

    if (!foundAccount) {
      if (accounts.length > GlobalConfiguration?.lengthCheckZero) {
        const fallback = preferredAssociateAccount;

        setCurrentAssociate(getAssociateLabel(fallback?.type_of_account));
      }
      setIsBankLinkedAccount(false);
      setIsCreateAccount(false);
    }
  }, [bankLookupData, payload]);

  useEffect(() => {
    if (
      !bankLookupLoading &&
      !ifscDetailsLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !isBankError &&
      isIFSCValid &&
      bankLookupError === true &&
      verifyBankAccountData
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupError,
    isBankError,
    verifyBankAccountData,
    isIFSCValid,
    ifscDetailsLoading,
  ]);

  return (
    <>
      <div className="flex flex-col gap-y-gap-md px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full">
            {virtualAccount && isIFSCValid ? (
              <>
                <div className="flex flex-row gap-x-gap-sm bg-emphasis p-padding-md rounded-border-radius-md mb-margin-md items-center">
                  <img
                    src={ICONS.VIRTUAL_ACCOUNT}
                    alt="Virtual Account"
                    className="w-icon-md h-icon-md "
                  />
                  <div className="flex flex-col gap-y-gap-sm">
                    <p className="text-font-sm text-text-primary font-semibold">
                      Virtual Account Detected
                    </p>
                    <ul className="flex flex-col gap-y-gap-sm list-disc list-inside ml-margin-xs">
                      <li className="text-font-xs text-text-primary font-normal">
                        Account could not be verified as it is a virtual
                        account.
                      </li>
                      <li className="text-font-xs text-text-primary font-normal">
                        Self-verify and proceed with caution.
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            ) : null}
            {hideBankBlock && !isBankError && !virtualAccount ? (
              <div className="bene_block_message_text">
                <img
                  src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className="flex flex-row gap-gap-sm p-padding-md w-width-full bg-emphasis items-center rounded-border-radius-md mb-margin-md">
                <img
                  src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md"
                />
                <p className="text-text-primary text-font-xs font-normal">
                  {TEXT?.ACCOUNT_ALREADY_LINKED}
                </p>
              </div>
            ) : null}
            <div
              className={`h-fit w-full lg:max-w-[var(--create-box-width)] ${type === "switch_account" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
            >
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={BenEnableNextButton}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                setShowDetails={setShowDetails}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={bankDetailsIfscData}
                ownerAccIfscError={ownerAccIfscError}
                ownerAccIfscLoading={ifscDetailsLoading}
                type={type}
              />
            </div>
          </div>
          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)]  ${
              type === "switch_account"
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            {isBankError === true &&
              canMarkAsVirtualAccount &&
              !verifyBankAccountLoading &&
              ownerAccIfscError === false &&
              !ifscDetailsLoading && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  onToggle={() => {
                    const nextState = !manualVirtualAccount;
                    setManualVirtualAccount(nextState);
                    setBankVerificationStatus(false);
                    setPayload((prev) => ({ ...prev, virtual: nextState }));
                  }}
                />
              )}

            {bankLookupLoading === false &&
              ifscDetailsLoading !== true &&
              verifyBankAccountLoading === false &&
              !(isBankLinkedAccount && isIFSCValid) && (
                <div style={{ overflow: "hidden" }}>
                  <div className="animate-slideInFromRight">
                    <ConfirmBtnAccCreation
                      type="bank"
                      status={
                        bankLookupData?.beneficiary_accounts?.length >
                        GlobalConfiguration?.lengthCheckZero
                      }
                      isIFSCValid={isIFSCValid}
                      isBankError={isBankError && !manualVirtualAccount}
                      lookupNext={
                        type === "switch_account" ? true : bankLookupNext
                      }
                      isButtonDisabled={
                        type === "switch_account"
                          ? false
                          : isBankLinkedAccount && isIFSCValid
                      }
                      nextButtonEnabled={
                        type === "switch_account" ? false : nextButtonEnabled
                      }
                      handleClick={() => {
                        if (type === "switch_account") return;
                        if (!isButtonDisabled && !isCreateAccount) {
                          setIsCreateAccount(false);
                          setBankIsApproved(false);
                          setBankLookupNext(true);
                          setBankIsArchived(false);
                          setBankIsDennied(false);
                          setBankIsPending(false);
                          setBankHideBlock(false);
                        }
                      }}
                    />
                  </div>
                </div>
              )}

            <div
              style={{
                display:
                  (hasValidInput &&
                    bankLookupData?.status &&
                    accounts?.length > GlobalConfiguration?.lengthCheckZero) ||
                  bankLookupLoading ||
                  verifyBankAccountLoading ||
                  virtualAccount
                    ? "block"
                    : isIFSCValid && isBankError
                      ? "none"
                      : "block",
              }}
            >
              <ActiveInactiveAssociatePopup
                flow={
                  isBankError === true && !manualVirtualAccount
                    ? "hideAssociate"
                    : isBankLinkedAccount && isIFSCValid
                      ? "Existing"
                      : showDetails
                        ? "notFoundBank"
                        : !showDetails && accounts?.length
                          ? "Bank"
                          : "defaultBank"
                }
                dropDownNo={associateDropDownNo}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.panNumber}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={(isOpen) => {
                  if (isOpen) {
                    const accountType =
                      currentAssociate === "Reimbursement account"
                        ? "reimbursement"
                        : "beneficiary";
                    const matchingAccounts = accounts.filter(
                      (account) => account?.type_of_account === accountType,
                    );
                    setAccActiveInactiveState(
                      matchingAccounts.length > 0 &&
                        matchingAccounts.every(
                          (account) =>
                            getActiveState(account?.approval_status) ===
                            "inactive",
                        )
                        ? "inactive"
                        : "active",
                    );
                  }
                  setOpenAssociatePopup(isOpen);
                }}
                ifscLength={payload?.ifsc_code?.length}
                currentRoute={"beneAccount"}
                accountTypeAvailability={accountTypeAvailability}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default CreateBank;
